import React from 'react'
import { formatNum } from 'scenarios/calculations'

/**
 * Clearance calculation table section
 * Shows the draft + tolerance - depth = min_tide calculation
 *
 * Simplified format for Scenarios 1 & 2 (no pilot sections)
 * No departure times shown - those go in DepartureOptions section
 *
 * @param {number} boatDraft - Vessel draft at departure
 * @param {number} tolerance - Safety clearance (0.75m)
 * @param {number} dockDepth - Depth at the dock
 * @param {string} dockLabel - Dock label
 * @param {string} minTide - Formatted min tide
 */
export const ClearanceCalc = ({ boatDraft, tolerance, dockDepth, dockLabel, minTide }) => (
    <>
        <h2>Calcul de dégagement / Clearance calculation :</h2>
        <p>
            <b>Dégagement / Clearance :</b>
        </p>
        <table cellSpacing='5'>
            <tbody>
                <tr>
                    <td width={20}></td>
                    <td width={60}>{formatNum(boatDraft)}</td>
                    <td width={30}>m</td>
                    <td>
                        Tirant d'eau du navire au départ
                        <br />
                        Vessel Draft at Departure
                    </td>
                </tr>
                <tr>
                    <td>+</td>
                    <td>{formatNum(tolerance)}</td>
                    <td>m</td>
                    <td>
                        Dégagement de sécurité sous quille 0.75 m
                        <br />
                        Under Keel Clearance 0.75 m
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td style={{ borderTop: '1px solid black' }}>
                        {formatNum(+boatDraft + +tolerance)}
                    </td>
                    <td>m</td>
                    <td>
                        Total du tirant d'eau plus le dégagement de sécurité sous quille
                        <br />
                        Total draft plus safety clearance under keel
                    </td>
                </tr>
                <tr>
                    <td>-</td>
                    <td>{formatNum(dockDepth) || '?'}</td>
                    <td>m</td>
                    <td>
                        Profondeur minimum au Quai {dockLabel}
                        <br />
                        Minimum Depth at Berth {dockLabel}
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td style={{ borderTop: '1px solid black' }}>
                        <b>{minTide}</b>
                    </td>
                    <td>m</td>
                    <td>
                        Marée minimum à laquelle le navire doit quitter
                        <br />
                        Minimal Tide for Vessel departure
                    </td>
                </tr>
            </tbody>
        </table>
    </>
)
